import { polylineStyle } from "./styles";

const GridBattery = ({ type }) => {
  const getAnimationPoints = () => {
    if (type === "down") {
      return {
        from: "10",
        to: "220",
      };
    } else {
      return {
        from: "220",
        to: "10",
      };
    }
  };

  const getLinePoints = () => {
    return {
      x1: 10,
      y1: 10,
      x2: 220,
      y2: 10,
    };
  };

  return (
    <svg
      height="20px"
      width="240px"
      style={{
        position: "absolute",
        top: "40px",
        left: "60px",
      }}>
      <defs>
        <marker
          id="pointerGBRlStart"
          markerWidth="8"
          markerHeight="10"
          refX="8"
          refY="5"
          orient="180"
          markerUnits="userSpaceOnUse"
          style={polylineStyle}>
          <polyline points="0 0, 8 5, 0 10" />
        </marker>
        <marker
          id="pointerGBRlEnd"
          markerWidth="8"
          markerHeight="10"
          refX="8"
          refY="5"
          orient="0"
          markerUnits="userSpaceOnUse"
          style={polylineStyle}>
          <polyline points="0 0, 8 5, 0 10" />
        </marker>
      </defs>
      <line
        {...getLinePoints()}
        strokeWidth="1"
        stroke="#004057"
        strokeLinecap="round"
        markerStart={type === "up" ? "url(#pointerGBRlStart)" : ""}
        markerEnd={type === "down" ? "url(#pointerGBRlEnd)" : ""}
      />
      <circle r="4" cx="10" cy="10" fill="#004057">
        <animate
          dur="3s"
          begin="0s"
          repeatCount="indefinite"
          attributeName="cx"
          {...getAnimationPoints()}
        />
      </circle>
    </svg>
  );
};

export default GridBattery;
